import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors, Grid, IconButton, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { insh, sto } from "../../../../Context/InshData";
import Print from "@material-ui/icons/Print";

// import { useStylesLbl } from "../../../../St/comps/UseStyle";
import { Autocomplete } from "@material-ui/lab";
import {
    useStylesAutoPurch
    , useStylesUiElemment,
    useStylesSpDial,
    useStylesLbl,
    useStylesAutoSafe,
    useStylesTF,
} from '../../../../St/Reports/UseStyle';
import { RetCheckbox, useStylesAuto, useStylesUp } from "../../../../St/comps/UseStyle";
import { stElemnt } from "../../../../St/comps/cStyle";
import Delete from "@material-ui/icons/Delete";
import i18next from "i18next";

const useStyles = makeStyles((theme) => ({
    table: {
        // minWidth: 650,
        minHeight: 500,
    },
}));

export default function InvoiceRestTable(props) {
    const { isdata, setIsData, maths, handSums,
        isPurches, isStock, isMake, permistionInv, handOSnack, setting, setConfirmDialog,
        isHedden, or, isOpenUpdate, setRowUpdate, mathsTab3val
    } = props;
    const [rowItem, setRowItem] = useState({});
    const handleFocus = (e) => e.target.select();
    let round = permistionInv?.ROUND == null ? 4 : permistionInv?.ROUND;


    const stylH = isPurches ? stElemnt.SubHPruch : isStock ? stElemnt.SubHSafes : isMake ? stElemnt.SubHMake : stElemnt.SubHMu;
    const stylRo = {
        ... stElemnt.SubR,
        padding: "5px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        BorderBottom: "solid 0.5px",
        fontSize: 12,
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        color: "#000"
    }
    
    // const stylRo = stElemnt.SubR;
    const stylRo2 = {
        padding: "0px 0px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        BorderBottom: "solid 0.5px",
        fontSize: 12,
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        width: "300px",
        maxWidth: "300px",
        minWidth: "200px",
        color: "#000"
    }
    const cellSD4 = {
        padding: "0px 0px",
        margin: "0px",
        fontSize: "0.7rem",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
        direction: "rtl",
        textAlign: "right",
        width: "300px",
        minWidth: "200px",
        color: "#000"
    };

    const calsPurch = useStylesAutoPurch();
    const claslbls = useStylesLbl();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasSaf = useStylesAutoSafe();
    const clasup = useStylesUp();
    const { t } = useTranslation(["forms"]);
    // const classes = useStyles();
    const onRowClick = (row) => {
        setRowUpdate(row);
    };
    const handleOpenUpdate = (props, e, row) => {

        if (or.postput == "toPut" && !isOpenUpdate) return;
        var newDataVal = isdata.filter((obj) => obj.editAbleVal === true);
        var newDataPrice = isdata.filter((obj) => obj.editAblePrice === true);
        var newDataUnit = isdata.filter((obj) => obj.editAbleUnit === true);
        var newDataTax = isdata.filter((obj) => obj.editAbleTax === true);
        var newDataDescM = isdata.filter((obj) => obj.editAbleDescM === true);
        var newDataDescP = isdata.filter((obj) => obj.editAbleDescP === true);
        var newDataNotes = isdata.filter((obj) => obj.editAbleDescNote === true);


        console.log("the rowItem data inve is", rowItem);

        if (rowItem?.no != null) {
            if (rowItem.no == row.no) {
                if (newDataVal.length != 0 && props !== "editAbleVal") {
                    EnterChangeTtems("val1", rowItem, row);
                } else if (newDataPrice.length != 0 && props !== "editAblePrice") {
                    EnterChangeTtems("new_exchange_price", rowItem, row);
                } else if (newDataTax.length != 0 && props !== "editAbleTax") {
                    EnterChangeTtems("taxperc", rowItem, row);
                } else if (newDataDescM.length != 0 && props !== "editAbleDescM") {
                    EnterChangeTtems("discount", rowItem, row);
                } else if (newDataDescP.length != 0 && props !== "editAbleDescP") {
                    EnterChangeTtems("DiscPers", rowItem, row);
                }
                else if (newDataNotes.length != 0 && props !== "editAbleDescNote") {
                    EnterChangeTtems("notes", rowItem, row);
                }
                else if (newDataUnit.length != 0 && props !== "editAbleUnit") {
                    EnterChangeTtems("val1", rowItem, row);
                    setRowItem({});
                }
            } else {
                if (newDataVal.length != 0) {
                    EnterChangeTtems("val1", rowItem, row);
                } else if (newDataPrice.length != 0) {
                    EnterChangeTtems("new_exchange_price", rowItem, row);
                } else if (newDataTax.length != 0) {
                    EnterChangeTtems("taxperc", rowItem, row);
                } else if (newDataDescM.length != 0) {
                    EnterChangeTtems("discount", rowItem, row);
                } else if (newDataDescP.length != 0) {
                    EnterChangeTtems("DiscPers", rowItem, row);
                }
                else if (newDataNotes.length != 0) {
                    EnterChangeTtems("notes", rowItem, row);
                }
                else if (newDataUnit.length != 0) {
                    EnterChangeTtems("val1", rowItem, row);
                    setRowItem({});
                }
            }
        } else {
            if (props === "editAbleVal") {
                var newData = isdata.filter((obj) => obj.editAbleVal === true);

                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = {
                    ...row,
                    editAbleVal: or.postput == "toPost" ? true :
                        or.postput == "toPut" && isOpenUpdate ? true : false,
                };
                setIsData([...dataUpdate]);



            } else  {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = {
                    ...row,
                    [props]: or.postput == "toPost" ? true :
                        or.postput == "toPut" && isOpenUpdate ? true : false,
                };
                setIsData([...dataUpdate]);
            }
        }

    };
    const changAutoCurrUnits = (row, newValue) => {

        let prc = setting.cusType == 1 ? newValue.sale : newValue.purch;
        let tot = (parseFloat(prc) * parseFloat(row.val1));
        let desc_mount = (
            parseFloat(tot) *
            (row.DiscPers / 100)
        );
        let totbef = (parseFloat(tot) - parseFloat(desc_mount));

        let taxMount = maths(
            parseFloat(totbef),
            parseFloat(row.taxperc),
            "taxval"
        );
        let betTax = maths(
            parseFloat(totbef),
            parseFloat(row.taxperc),
            "before_vat"
        );

        let resNetA = maths(
            parseFloat(totbef),
            parseFloat(row.taxperc),
            "Net"
        );
        let tot_before_vat_with_tab3val = 0;
        if (parseFloat(row?.tab3val_sub) > 0 && parseFloat(row.taxperc) > 0 && permistionInv?.USETOBACO) {
            let tot_before_new = maths(
                parseFloat(prc),
                parseFloat(row.taxperc),
                "before_vat"
            );
            tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * row.val1) : parseFloat(betTax).toFixed(2);

            let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

            taxMount = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(row.taxperc),
                "taxval"
            );

            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                + parseFloat(taxMount)).toFixed(2);
        }
        let val1 = row.val1 == 0 ? 1 : row.val1;
        let itemType = Number(row?.type);

        let subInfoVal1_perc = row.val1 * newValue.perc;
        let countsCurr = parseInt(row?.Qtys ?? 0) - parseInt(val1);
        if (permistionInv.SIM == false &&
            countsCurr < subInfoVal1_perc && itemType != 4 &&
            (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
            const index = row?.no;
            const dontUpdateData = [...isdata];
            dontUpdateData[index] = {
                ...row,
                editAbleUnit: false,
            };
            setIsData([...dontUpdateData]);
            setRowItem({});
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: "الكمية المدخلة للصنف أكبر من رصيد المخزن",
                time: 2000,
            });
        } else {
            const index = rowItem?.no;
            const dataUpdate = [...isdata];
            dataUpdate[index] = {
                ...rowItem,
                totJust: tot,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                new_exchange_price: setting.cusType == 1 ? newValue.sale : newValue.purch,
                perc: newValue.perc,
                PricePu: newValue.purch,
                unitame: newValue.unitName,
                unit: newValue.unit,
                val: newValue.perc,
                defUnit: newValue,
                discount: desc_mount,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
                editAbleUnit: false,
            };
            setIsData([...dataUpdate]);
            handSums(dataUpdate);
            setRowItem({});
        }
    };
    const handleDeleteRow = (e, row) => {
        e.preventDefault();
        var newData = isdata.filter((obj) => obj.no !== row.no);
        const newItems = newData.map((row, i) => {
            return {
                ...row,
                no: i,
            };
        });
        setIsData([...newItems]);
        handSums(newData);
        setConfirmDialog(false);
        setRowItem({});

    };

    const MathChangIdataTtems = (prop, row) => (event) => {
        let i = {
            res: prop !== "notes" ? Number(event.target.value) : event.target.value,
            val1: Number(row.val1),
            val: Number(row.val),
            new_exchange_price: Number(row.new_exchange_price),
            totJust: Number(row.totJust),
            discount: Number(row.discount),
            DiscPers: Number(row.DiscPers),
            totAfterDisc: Number(row.totAfterDisc),
            taxperc: Number(row.taxperc),
            taxval: Number(row.taxval),
            netAmountSub: Number(row.netAmountSub),
            sale_price: Number(row.sale_price),
            PricePu: Number(row.PricePu),
            minPrice: Number(row.minPrice),
        };
        if (prop === "new_exchange_price") {
            let tot = parseFloat(i.res * i.val1);
            let desc_mount = (
                parseFloat(tot) *
                (i.DiscPers / 100)
            );
            let totBe = parseFloat((i.res * i.val1) - desc_mount);


            let taxMount = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "taxval"
            );
            let betTax = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "before_vat"
            );

            let resNetA = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(row?.tab3val_sub) > 0 && parseFloat(i.taxperc) > 0 && permistionInv?.USETOBACO) {
                let tot_before_new = maths(
                    parseFloat(i.res),
                    parseFloat(i.taxperc),
                    "before_vat"
                );
                tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                    (parseFloat(25) * i.val1) : parseFloat(betTax).toFixed(2);

                let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                taxMount = mathsTab3val(
                    parseFloat(tot_before),
                    parseFloat(i.taxperc),
                    "taxval"
                );

                resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                    + parseFloat(taxMount)).toFixed(2);
            }
            setRowItem({
                ...row,
                totJust: tot,
                new_exchange_price: event.target.value,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                discount: desc_mount,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
            });
        }
        else if (prop === "val1") {
            let val1 = i.res == 0 ? 1 : i.res;
            let tot = parseFloat(val1 * i.new_exchange_price);
            let desc_mount = (
                parseFloat(tot) *
                (i.DiscPers / 100)
            );
            let totBe = parseFloat((val1 * i.new_exchange_price) - desc_mount);

            let taxMount = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "taxval"
            );
            let betTax = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "before_vat"
            );

            let resNetA = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(row?.tab3val_sub) > 0 && parseFloat(i.taxperc) > 0 && permistionInv?.USETOBACO) {
                let tot_before_new = maths(
                    parseFloat(i.new_exchange_price),
                    parseFloat(i.taxperc),
                    "before_vat"
                );
                tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                    (parseFloat(25) * i.res) : parseFloat(betTax).toFixed(2);

                let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                taxMount = mathsTab3val(
                    parseFloat(tot_before),
                    parseFloat(i.taxperc),
                    "taxval"
                );

                resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                    + parseFloat(taxMount)).toFixed(2);
            }
            setRowItem({
                ...row,
                totJust: tot,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                val1: event.target.value,
                discount: desc_mount,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
            });

        }
        else if (prop === "discount") {

            let tot = parseFloat(i.new_exchange_price * i.val1);

            let totBe = parseFloat((i.new_exchange_price * i.val1) - i.res);

            let desc_perc = (
                (i.res * 100) /
                parseFloat(tot)
            );
            let taxMount = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "taxval"
            );
            let betTax = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "before_vat"
            );

            let resNetA = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(row?.tab3val_sub) > 0 && parseFloat(i.taxperc) > 0 && permistionInv?.USETOBACO) {
                let tot_before_new = maths(
                    parseFloat(i.new_exchange_price),
                    parseFloat(i.taxperc),
                    "before_vat"
                );
                tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                    (parseFloat(25) * i.val1) : parseFloat(betTax).toFixed(2);

                let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                taxMount = mathsTab3val(
                    parseFloat(tot_before),
                    parseFloat(i.taxperc),
                    "taxval"
                );

                resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                    + parseFloat(taxMount)).toFixed(2);
            }
            setRowItem({
                ...row,
                totJust: tot,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                DiscPers: desc_perc,
                discount: event.target.value,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
            });
        }
        else if (prop === "DiscPers") {

            let tot = parseFloat(i.new_exchange_price * i.val1);
            let desc_mount = (
                parseFloat(tot) *
                (i.res / 100)
            );
            let totBe = parseFloat((i.new_exchange_price * i.val1) - desc_mount);
            let taxMount = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "taxval"
            );
            let betTax = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "before_vat"
            );

            let resNetA = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(row?.tab3val_sub) > 0 && parseFloat(i.taxperc) > 0 && permistionInv?.USETOBACO) {
                let tot_before_new = maths(
                    parseFloat(i.new_exchange_price),
                    parseFloat(i.taxperc),
                    "before_vat"
                );
                tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                    (parseFloat(25) * i.val1) : parseFloat(betTax).toFixed(2);

                let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                taxMount = mathsTab3val(
                    parseFloat(tot_before),
                    parseFloat(i.taxperc),
                    "taxval"
                );

                resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                    + parseFloat(taxMount)).toFixed(2);
            }
            setRowItem({
                ...row,
                totJust: tot,
                discount: desc_mount,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                DiscPers: event.target.value,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
            });


        }
        else if (prop === "taxperc") {


            let tot = parseFloat(i.new_exchange_price * i.val1);
            let desc_mount = (
                parseFloat(tot) *
                (i.DiscPers / 100)
            );
            let totBe = parseFloat((i.new_exchange_price * i.val1) - desc_mount);

            let taxMount = maths(
                parseFloat(totBe),
                parseFloat(i.res),
                "taxval"
            );
            let betTax = maths(
                parseFloat(totBe),
                parseFloat(i.res),
                "before_vat"
            );

            let resNetA = maths(
                parseFloat(totBe),
                parseFloat(i.res),
                "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(row?.tab3val_sub) > 0 && parseFloat(i.res) > 0 && permistionInv?.USETOBACO) {
                let tot_before_new = maths(
                    parseFloat(i.new_exchange_price),
                    parseFloat(i.res),
                    "before_vat"
                );
                tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                    (parseFloat(25) * i.val1) : parseFloat(betTax).toFixed(2);

                let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                taxMount = mathsTab3val(
                    parseFloat(tot_before),
                    parseFloat(i.res),
                    "taxval"
                );

                resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                    + parseFloat(taxMount)).toFixed(2);
            }
            setRowItem({
                ...row,
                totJust: tot,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                taxperc: event.target.value,
                discount: desc_mount,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
            });
        }
        else if (prop === "notes") {
            setRowItem({
                ...row,
                notes: event.target.value,
            });
        }
    };

    const EnterChangeTtems = (prop, rowItem, row) => {
        let i = {
            val1: Number(rowItem.val1),
            val: Number(rowItem.val),
            new_exchange_price: Number(rowItem.new_exchange_price),
            totJust: Number(rowItem.totJust),
            discount: Number(rowItem.discount),
            DiscPers: Number(rowItem.DiscPers),
            totAfterDisc: Number(rowItem.totAfterDisc),
            taxperc: Number(rowItem.taxperc),
            taxval: Number(rowItem.taxval),
            netAmountSub: Number(rowItem.netAmountSub),
            sale_price: Number(rowItem.sale_price),
            PricePu: Number(rowItem.PricePu),
            minPrice: Number(rowItem.minPrice),

        };
        if (prop === "new_exchange_price") {
            const index = rowItem?.no;
            const dataUpdate = [...isdata];

            if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12") &&
                permistionInv.SNOP === true && rowItem != null &&
                parseFloat(i.new_exchange_price) < parseFloat(i.PricePu)) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAblePrice: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `لا يمكن البيع اقل من سعر الشراء للصنف سعر الشراء المسجل للصنف هو : 
                    ${row.PricePu}`,
                    time: 2000,
                });
            }
            else if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
                && permistionInv.SNOMIN === 1 &&
                parseFloat(i.new_exchange_price ?? 0) < parseFloat(i.minPrice)) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAblePrice: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `لا يمكن البيع اقل من السعر الادنى للصنف السعر الادنى المسجل للصنف هو :  ${row.minPrice}`,
                    time: 2000,
                });
            } else if (parseFloat(i.new_exchange_price ?? 0) < 0) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAblePrice: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: "لا يمكن البيع بسعر بقيمة سالبة ",
                    time: 2000,
                });
            }
            else if ((setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12") &&
                permistionInv.ASPZ === false && i.new_exchange_price <= 0) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAblePrice: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `لا يوجد لديك صلاحية البيع بسعر صفر `,
                    time: 2000,
                });
            }
            else if ((setting.PrTy_InPr == "01" || setting.PrTy_InPr == "11") &&
                permistionInv.ASPZ === false && i.new_exchange_price <= 0) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAblePrice: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `لا يوجد لديك صلاحية الشراء بسعر صفر `,
                    time: 2000,
                });
            }
            else {

                dataUpdate[index] = {
                    ...rowItem,
                    val1: rowItem.val1,
                    val: rowItem.val,
                    discount: rowItem.discount,
                    new_exchange_price: i.new_exchange_price,
                    DiscPers: rowItem.DiscPers,
                    taxperc: rowItem.taxperc,
                    editAblePrice: false,
                };
                setIsData([...dataUpdate]);
                handSums(dataUpdate);
                setRowItem({});
            }

        }
        else if (prop === "val1") {
            let val1 = i.val1 == 0 ? 1 : rowItem.val1;
            let subInfoVal1_perc = val1 * i.val;
            //   let countsCurr = parseInt(rowItem?.balance) - parseInt(rowItem?.val1);
            let totValbef = 0.0;
            for (let m = 0; m < isdata.length; m++) {
                if (row.currency_from == isdata[m].currency_from && row.no != isdata[m]?.no)
                    totValbef += (isdata[m].val1 * isdata[m].val);
            };
            let val = Number(row?.Qtys);
            let itemType = Number(row?.type);


            let countsCurr = parseInt(val ?? 0) - Number(totValbef);
            console.log("the olllll is", totValbef);

            console.log("the olllll is", countsCurr);

            const index = rowItem?.no;
            const dataUpdate = [...isdata];
            if (permistionInv.SIM == false &&
                countsCurr < subInfoVal1_perc && itemType != 4 &&
                (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAbleVal: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: "الكمية المدخلة للصنف أكبر من رصيد المخزن",
                    time: 2000,
                });
            } else if (rowItem.val1 < 0 || rowItem.val1 == 0) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAbleVal: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: "لا يمكن ان تكون الكمية سالبة",
                    time: 2000,
                });
            }
            else {

                dataUpdate[index] = {
                    ...rowItem,
                    val1: val1,
                    val: rowItem.val,
                    discount: rowItem.discount,
                    new_exchange_price: i.new_exchange_price,
                    DiscPers: rowItem.DiscPers,
                    taxperc: rowItem.taxperc,
                    editAbleVal: false,
                };
                setIsData([...dataUpdate]);
                handSums(dataUpdate);
                setRowItem({});
            }


        }
        else if (prop === "discount") {

            if (permistionInv.APDC === 2 && permistionInv.DSOI == 1 &&
                (parseFloat(i.discount) > parseFloat(permistionInv.SDV)) ||
                parseFloat(i.discount) > parseFloat(rowItem.totJust)) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAbleDescM: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `
        لقد تجاوزت مبلغ الخصم المسموح بها
        مبلغ الخصم المسموح بة : ${parseFloat(permistionInv.SDV)
                        }
        `,
                    time: 2000,
                });
            }
            else {
                const index = rowItem?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = {
                    ...rowItem,
                    val1: rowItem.val1,
                    val: rowItem.val,
                    discount: i.discount,
                    new_exchange_price: rowItem.new_exchange_price,
                    DiscPers: rowItem.DiscPers,
                    taxperc: rowItem.taxperc,
                    editAbleDescM: false,
                };
                setIsData([...dataUpdate]);
                handSums(dataUpdate);
                setRowItem({});
            }
        }
        else if (prop === "DiscPers") {

            if (permistionInv.APDC === 1 && permistionInv.DSOI == 1
                && parseFloat(i.DiscPers) > parseFloat(permistionInv.SDP)) {

                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAbleDescP: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `
                    لقد تجاوزت نسبة الخصم المسموح بها
                    نسبة الخصم المسموح بها : ${parseFloat(permistionInv.SDP)
                        }
                    `,
                    time: 2000,
                });
            }
            else {
                const index = rowItem?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = {
                    ...rowItem,
                    val1: rowItem.val1,
                    val: rowItem.val,
                    discount: rowItem.discount,
                    new_exchange_price: rowItem.new_exchange_price,
                    DiscPers: i.DiscPers,
                    taxperc: rowItem.taxperc,
                    editAbleDescP: false,
                };
                setIsData([...dataUpdate]);
                handSums(dataUpdate);
                setRowItem({});
            }
        }

        else if (prop === "taxperc") {
            const index = rowItem?.no;
            const dataUpdate = [...isdata];
            dataUpdate[index] = {
                ...rowItem,
                val1: rowItem.val1,
                val: rowItem.val,
                discount: rowItem.discount,
                new_exchange_price: rowItem.new_exchange_price,
                DiscPers: rowItem.DiscPers,
                taxperc: i.taxperc,
                editAbleTax: false,
            };
            setIsData([...dataUpdate]);
            handSums(dataUpdate);
            setRowItem({});
        } else if (prop === "notes") {
            const index = rowItem?.no;
            const dataUpdate = [...isdata];
            dataUpdate[index] = {
                ...rowItem,
                val1: rowItem.val1,
                val: rowItem.val,
                discount: rowItem.discount,
                new_exchange_price: rowItem.new_exchange_price,
                DiscPers: rowItem.DiscPers,
                taxperc: i.taxperc,
                editAbleDescNote: false,
            };
            setIsData([...dataUpdate]);
            handSums(dataUpdate);
            setRowItem({});
        }

    };

    return (
        <Grid item container className={clasup.rootupMu}
        >
            <TableContainer component={Paper}  //className={classes.table} 
                style={{
                    minHeight: 400, maxHeight: 650, direction: i18next.language == "ar" ? "rtl" : "ltr"
                }} >
                <Table
                    size="small" aria-label="a dense table" >
                    <TableHead>
                        <TableRow
                            style={{
                                backgroundColor: isPurches ? colors.blue[300] : colors.green[300],
                                color: "#000",
                                border: "solid 0.6px"
                            }}
                        >
                            <TableCell style={stylH} align="center">
                                {t("item")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("unit")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("quanity")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("price")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("total")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("discount_mount")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("discount_perc")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("total_after_discount")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("tobacco_tax")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("vat_perc")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("vat_total")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("net")}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isdata.map((row) => (
                           <>
                            <TableRow key={row.currency_from}
                                style={{
                                    padding: "5px 0px",
                                    textAlign: "-webkit-center",
                                    margin: "0px",
                                    whiteSpace: "nowrap",
                                    color: "#000",
                                    fontWeight: 600,
                                    fontFamily: "Amiri-Regular",
                                    fontSize: 12,
                                    border: "solid 0.6px"
                                }}
                            >
                                <TableCell style={stylRo2} align="center" onClick={() => { onRowClick(row); }} >{row.symbol}</TableCell>

                                <TableCell style={stylRo} align="center"
                                    onDoubleClick={(event) => handleOpenUpdate("editAbleUnit", event, row)}
                                >
                                    {
                                        row?.editAbleUnit && row?.UnitsTable?.length > 1 ? (
                                            <Autocomplete
                                                autoHighlight
                                                openOnFocus
                                                classes={isPurches ? calsPurch : isStock ? clasSaf : clasAo}
                                                value={row.defUnit}
                                                onChange={(event, newValue) => {
                                                    changAutoCurrUnits(row, newValue);
                                                }}
                                                id="combo-box-demo"
                                                options={row?.UnitsTable}
                                                getOptionLabel={(option) =>
                                                    typeof option === "string" ? option : option.unitName
                                                }
                                                onBlur={(e) => EnterChangeTtems("val1", rowItem, row)}
                                                disableClearable
                                                style={{ backgroundColor: colors.green[50] }}
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label={"الوحدة"}
                                                        variant="outlined"
                                                        InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                                    />
                                                )}

                                            />
                                        ) :
                                            (
                                                row.unitame
                                            )

                                    }
                                </TableCell>

                                <TableCell style={stylRo} align="center"
                                    onDoubleClick={(event) => handleOpenUpdate("editAbleVal", event, row)}
                                >
                                    {
                                        row.editAbleVal ?
                                            (
                                                <>
                                                    <TextField fullWidth
                                                        variant="outlined" size="small"
                                                        id="val1"
                                                        className={clasTF.rootSafe}
                                                        style={{ backgroundColor: colors.grey[50] }}
                                                        type="number"
                                                        name="val1"
                                                        onBlur={(e) => EnterChangeTtems("val1", rowItem, row)}
                                                        value={rowItem.val1}
                                                        onChange={MathChangIdataTtems("val1", row)}
                                                        autoFocus={true}
                                                        onFocus={handleFocus}
                                                        InputProps={{
                                                            className: claslbl.clrSafe,
                                                            onKeyDown: (event) => {
                                                                if (event.key === 'Enter') {
                                                                    EnterChangeTtems("val1", rowItem, row);
                                                                }
                                                            },
                                                            onBlur: () => {
                                                                EnterChangeTtems("val1", rowItem, row);
                                                            },
                                                        }}
                                                    />

                                                </>

                                            ) : (
                                                parseFloat(row.val1)?.toFixed(2)
                                            )}
                                </TableCell>

                                <TableCell style={stylRo} align="center"
                                    onDoubleClick={(event) => handleOpenUpdate("editAblePrice", event, row)}
                                >
                                    {
                                        row.editAblePrice && permistionInv.USP ?
                                            (
                                                <>

                                                    <TextField fullWidth variant="outlined" size="small"
                                                        id="new_exchange_price"
                                                        // label=" السعر"
                                                        className={clasTF.rootSafe}
                                                        style={{ backgroundColor: colors.grey[50], marginBlock: 5 }}
                                                        type="number"
                                                        name="new_exchange_price"
                                                        value={rowItem.new_exchange_price}
                                                        onChange={MathChangIdataTtems("new_exchange_price", row)}
                                                        autoFocus={true}
                                                        onFocus={handleFocus}
                                                        InputProps={{
                                                            className: claslbl.clrSafe,
                                                            onKeyDown: (event) => {
                                                                if (event.key === 'Enter') {
                                                                    EnterChangeTtems("new_exchange_price", rowItem, row)
                                                                }
                                                            },
                                                            onBlur: () => {
                                                                EnterChangeTtems("new_exchange_price", rowItem, row)
                                                            },
                                                        }}
                                                    />

                                                </>

                                            ) :
                                            (
                                                parseFloat(row.new_exchange_price)?.toFixed(round)
                                            )}
                                </TableCell>

                                <TableCell style={stylRo} align="center"  > {parseFloat(row.totJust)?.toFixed(2)}</TableCell>
                                <TableCell style={stylRo} align="center"
                                    onDoubleClick={(event) => handleOpenUpdate("editAbleDescM", event, row)}
                                >
                                    {
                                        row.editAbleDescM && (permistionInv.APDC === 2 || permistionInv.APDC === 3)
                                            && permistionInv.DSOI == 1 ?
                                            (
                                                <>
                                                    <TextField fullWidth variant="outlined" size="small"
                                                        id="discount"
                                                        className={clasTF.rootSafe}
                                                        style={{ backgroundColor: colors.grey[50], marginBlock: 5 }}
                                                        type="number"
                                                        name="discount"
                                                        value={rowItem.discount}
                                                        onChange={MathChangIdataTtems("discount", row)}
                                                        autoFocus={true}
                                                        onFocus={handleFocus}
                                                        InputProps={{
                                                            className: claslbl.clrSafe,
                                                            onKeyDown: (event) => {
                                                                if (event.key === 'Enter') {
                                                                    EnterChangeTtems("discount", rowItem, row)
                                                                }
                                                            },
                                                            onBlur: () => {
                                                                EnterChangeTtems("discount", rowItem, row)
                                                            },
                                                        }}
                                                    />

                                                </>

                                            ) : (
                                                parseFloat(row.discount)?.toFixed(2)
                                            )}
                                </TableCell>

                                <TableCell style={stylRo} align="center"
                                    onDoubleClick={(event) => handleOpenUpdate("editAbleDescP", event, row)}
                                >
                                    {
                                        row.editAbleDescP && (permistionInv.APDC === 1 || permistionInv.APDC === 3) && permistionInv.DSOI == 1 ?
                                            (
                                                <>
                                                    <TextField fullWidth variant="outlined" size="small"
                                                        id="val1"
                                                        className={clasTF.rootSafe}
                                                        style={{ backgroundColor: colors.grey[50], marginBlock: 5 }}
                                                        type="number"
                                                        name="DiscPers"
                                                        value={rowItem.DiscPers}
                                                        onChange={MathChangIdataTtems("DiscPers", row)}
                                                        autoFocus={true}
                                                        onFocus={handleFocus}
                                                        InputProps={{
                                                            className: claslbl.clrSafe,
                                                            onKeyDown: (event) => {
                                                                if (event.key === 'Enter') {
                                                                    EnterChangeTtems("DiscPers", rowItem, row)
                                                                }
                                                            },
                                                            onBlur: () => {
                                                                EnterChangeTtems("DiscPers", rowItem, row)
                                                            },
                                                        }}
                                                    />

                                                </>

                                            ) : (
                                                parseFloat(row.DiscPers)?.toFixed(4)
                                            )}
                                </TableCell>
                                <TableCell style={stylRo} align="center"  > {parseFloat(row.totAfterDisc)?.toFixed(2) ?? "-"}</TableCell>
                                <TableCell style={stylRo} align="center"  > {parseFloat(row.tab3Val)?.toFixed(2) ?? "-"}</TableCell>
                                <TableCell style={stylRo} align="center"
                                    onDoubleClick={(event) => handleOpenUpdate("editAbleTax", event, row)}
                                >
                                    {
                                        row.editAbleTax && permistionInv.SVU ?
                                            (
                                                <>
                                                    <TextField fullWidth variant="outlined" size="small"
                                                        id="taxperc"
                                                        className={clasTF.rootSafe}
                                                        style={{ backgroundColor: colors.grey[50], marginBlock: 5 }}
                                                        type="number"
                                                        name="taxperc"
                                                        value={rowItem?.taxperc}
                                                        onChange={MathChangIdataTtems("taxperc", row)}
                                                        autoFocus={true}
                                                        onFocus={handleFocus}
                                                        InputProps={{
                                                            className: claslbl.clrSafe,
                                                            onKeyDown: (event) => {
                                                                if (event.key === 'Enter') {
                                                                    EnterChangeTtems("taxperc", rowItem, row)
                                                                }
                                                            },
                                                            onBlur: () => {
                                                                EnterChangeTtems("taxperc", rowItem, row)
                                                            },
                                                        }}
                                                    />

                                                </>

                                            ) :
                                            (
                                                parseFloat(row.taxperc)?.toFixed(4)
                                            )}
                                </TableCell>
                                <TableCell style={stylRo} align="center" >{row.taxval}</TableCell>
                                <TableCell style={stylRo} align="center" >{row.netAmountSub}</TableCell>

                            </TableRow>
                            <TableRow key={row.currency_from}
                                style={{
                                    padding: "5px 0px",
                                    textAlign: "-webkit-center",
                                    margin: "0px",
                                    whiteSpace: "nowrap",
                                    color: "#000",
                                    border: "solid 0.6px"
                                }}
                            >
                                <TableCell style={cellSD4} align="center" colSpan={4}
                                    onDoubleClick={(event) => handleOpenUpdate("editAbleDescNote", event, row)}
                                >
                                    {
                                        row.editAbleDescNote ?
                                            (
                                                <>
                                                    <TextField fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        id="notes"
                                                        className={clasTF.rootSafe}
                                                        style={{ ...cellSD4, backgroundColor: colors.grey[50] }}
                                                        type="text"
                                                        name="notes"
                                                        value={rowItem.notes}
                                                        onChange={MathChangIdataTtems("notes", row)}
                                                        autoFocus={true}
                                                        onFocus={handleFocus}
                                                        multiline
                                                        InputProps={{
                                                            className: claslbl.clrSafe,
                                                            onBlur: () => {
                                                                EnterChangeTtems("notes", rowItem, row)
                                                            },
                                                        }}
                                                    />

                                                </>

                                            ) : (
                                                row.notes
                                            )}
                                </TableCell>
                                <TableCell style={stylRo} align="right" colSpan={4}>{ }</TableCell>
                                <TableCell style={stylRo} align="center" colSpan={4}> { }</TableCell>

                            </TableRow>
                            <TableRow key={row.id}
                                style={{
                                    padding: "5px 0px",
                                    textAlign: "-webkit-center",
                                    margin: "0px",
                                    whiteSpace: "nowrap",
                                    color: "#000",
                                    border: "solid 0.6px"
                                }}
                            >
                               
                                
                                <TableCell   align="right"  colSpan={12}>
                                {(or.postput === "toPost" || 
                                    ( or.postput == "toPut" && isOpenUpdate )) &&
                                        (
                                           <>
                                            <IconButton
                                                color="primary"
                                                aria-label="upload picture"
                                                style={{ maxHeight: "0.5rem" }}
                                                onClick={(e) => {
                                                    setConfirmDialog({
                                                        isOpen: true,
                                                        onConfirm: () => {
                                                            handleDeleteRow(e, row);
                                                        },
                                                    })
                                                }}
                                            >
                                                <Delete size={"small"} />
                                            </IconButton>
                                            <IconButton
                                                color="primary"
                                                aria-label="upload picture"
                                                style={{ maxHeight: "0.5rem" }}
                                                onClick={(e) => {
                                                    setConfirmDialog({
                                                        isOpen: true,
                                                        onConfirm: () => {
                                                            handleDeleteRow(e, row);
                                                        },
                                                    })
                                                }}
                                            >
                                                <Delete size={"small"} />
                                            </IconButton>
                                            <IconButton
                                                color="primary"
                                                aria-label="upload picture"
                                                style={{ maxHeight: "0.5rem" }}
                                                onClick={(e) => {
                                                    setConfirmDialog({
                                                        isOpen: true,
                                                        onConfirm: () => {
                                                            handleDeleteRow(e, row);
                                                        },
                                                    })
                                                }}
                                            >
                                                <Delete size={"small"} />
                                            </IconButton>
                                            <IconButton
                                                color="primary"
                                                aria-label="upload picture"
                                                style={{ maxHeight: "0.5rem" }}
                                                onClick={(e) => {
                                                    setConfirmDialog({
                                                        isOpen: true,
                                                        onConfirm: () => {
                                                            handleDeleteRow(e, row);
                                                        },
                                                    })
                                                }}
                                            >
                                                <Delete size={"small"} />
                                            </IconButton>
                                           </>
                                        ) 
                                    }
                                </TableCell>
                                
                                {/* <TableCell style={stylRo} align="right" colSpan={4}>{ }</TableCell> */}
                                {/* <TableCell style={stylRo} align="center" colSpan={4}> { }</TableCell> */}
                            </TableRow>
                           </>
                        ))}
                    </TableBody>
                    
                </Table>
            </TableContainer>
        </Grid>
    );
}
